import React, { FunctionComponent } from 'react'
import AuthWrap from './AuthWrap'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import { CardHeader } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import { useLocation } from 'react-router-dom'
import { RouteState } from '../../typings/router.def'
import { useTranslation } from 'react-i18next'

const NoMatch: FunctionComponent = () => {
  const location = useLocation()
  const { t } = useTranslation()
  return (
    <AuthWrap>
      <CardHeader
        subheader={'Seite konnte nicht gefunden werden'}
        title={'404'}
      />
      <CardContent>
        <i>{location.pathname}</i> {t('')}
      </CardContent>
      <CardActions>
        <Button href={RouteState.Login} startIcon={<ChevronRightIcon />}>
          {t('login')}
        </Button>
      </CardActions>
    </AuthWrap>
  )
}

export default NoMatch
